import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Navigate = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Navigate' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M20,11 L22,8 L20,5 L12,5 L12,11 L20,11 Z M12,24 L12,0 M4,2 L2,5 L4,8 L12,8 L12,2 L4,2 Z' />
  </StyledIcon>
);
